module.exports = __webpack_public_path__ + "static/media/excel.d91d1233.svg";